function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef, useCallback } from "react";
import classNames from "classnames";
import { TEXT_TYPES, Text } from "#library/components/Text/Text";
import { Link } from "#library/components/Link";
import styles from "./Readmore.module.css";
export var ReadMore = function ReadMore(_ref) {
  var readMoreText = _ref.readMoreText,
    _ref$lineLimit = _ref.lineLimit,
    lineLimit = _ref$lineLimit === void 0 ? 3 : _ref$lineLimit,
    children = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? TEXT_TYPES.NORMAL : _ref$type,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return null;
    } : _ref$onClick;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasUserInteracted = _useState4[0],
    setHasUserInteracted = _useState4[1];
  var clampedTextRef = useRef(null);
  var handleClick = useCallback(function () {
    setIsExpanded(true);
    setHasUserInteracted(true);
    onClick();
  }, [onClick]);
  var handleKeyDown = useCallback(function (event) {
    if (event.nativeEvent.code === "Enter") {
      setIsExpanded(true);
      setHasUserInteracted(true);
    }
  }, []);
  useEffect(function () {
    var clampedText = clampedTextRef === null || clampedTextRef === void 0 ? void 0 : clampedTextRef.current;
    if (!clampedText) return function () {
      return null;
    };
    var useMaxHeightClamp = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (useMaxHeightClamp) {
      clampedText.classList.add(styles["jds-ReadMore__truncatedText--max-height"]);
    }
    if (!hasUserInteracted) {
      var isExpandedCalc = clampedText.scrollHeight <= clampedText.clientHeight;
      setIsExpanded(isExpandedCalc);
    }
    var observer = new ResizeObserver(function () {
      if (!hasUserInteracted) {
        var _isExpandedCalc = clampedText.scrollHeight <= clampedText.clientHeight;
        setIsExpanded(_isExpandedCalc);
      }
    });
    observer.observe(clampedText);
    return function () {
      observer.disconnect();
    };
  }, [hasUserInteracted]);
  var containerClassNames = classNames(_defineProperty(_defineProperty({}, styles["jds-ReadMore__truncatedText--expanded"], hasUserInteracted), styles["jds-ReadMore__truncatedText"], !hasUserInteracted));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: clampedTextRef,
    className: containerClassNames,
    style: {
      "--lineNumber": lineLimit
    }
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "div",
    type: type,
    resetSpacing: true
  }, children)), !isExpanded && /*#__PURE__*/React.createElement(Link, {
    isButton: true,
    onKeyDown: handleKeyDown,
    onClick: handleClick,
    className: styles["jds-ReadMore__link"],
    minor: type === "small"
  }, readMoreText));
};